module.exports = __webpack_public_path__ + "img/trainer1.23168d4a.svg";